<div class="smartlist-filter">
  <div class="filter-bar">
    <mat-icon class="search-icon" (click)="onClickSearch()">search</mat-icon>
    <div class="filters ch-flex-grid">
      <ng-content></ng-content>
    </div>
  </div>
</div>
